import { DAY_SHORT, formatBlockHours } from "./zone-conversion.js";
import { daysOfWeekFrom } from "./week-order.js";
import "react";
import { Tag } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
// src/modules/Scheduling/shared/availability/UnavailableTimeChips.tsx
function UnavailableTimeChips({ blocks, emptyLabel, firstDayOfWeek }) {
	if (!blocks?.length) return emptyLabel ? /* @__PURE__ */ jsx("span", {
		className: "text-color-subtle text-sm italic",
		children: emptyLabel
	}) : null;
	const ordered = firstDayOfWeek ? sortByWeek(blocks, daysOfWeekFrom(firstDayOfWeek)) : blocks;
	return /* @__PURE__ */ jsx("div", {
		className: "gap-xs flex flex-wrap",
		children: ordered.map((block, index) => /* @__PURE__ */ jsx(Tag, { value: /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("span", {
			className: "text-color-critical",
			children: DAY_SHORT[block.day]
		}), formatBlockHours(block) && /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("span", {
			className: "font-bold",
			children: " · "
		}), formatBlockHours(block)] })] }) }, index))
	});
}
function sortByWeek(blocks, week) {
	return [...blocks].sort((a, b) => week.indexOf(a.day) - week.indexOf(b.day));
}
export { UnavailableTimeChips };

//# sourceMappingURL=UnavailableTimeChips.js.map